export const regionOptions = [
  { label: "北美（NA）", value: "https://sellingpartnerapi-na.amazon.com" },
  { label: "欧洲（EU）", value: "https://sellingpartnerapi-eu.amazon.com" },
  { label: "远东（FE）", value: "https://sellingpartnerapi-fe.amazon.com" },
];

export function blankConfig() {
  return { id: null, shopName: "", enabled: false, proxyIp: "", proxyPort: 8888,
    sellerId: "", marketplaceId: "", amazonEndpoint: regionOptions[0].value };
}

// Only send editable fields; timestamps are maintained by the server.
export function savePayload(config) {
  const payload = { ...blankConfig() };
  Object.keys(payload).forEach(key => { payload[key] = config[key]; });
  ["shopName", "proxyIp", "sellerId", "marketplaceId", "amazonEndpoint"].forEach(key => {
    payload[key] = typeof payload[key] === "string" ? payload[key].trim() : "";
  });
  return payload;
}

export function validIp(value) {
  const ip = (value || "").trim();
  if (/^\d+\.\d+\.\d+\.\d+$/.test(ip)) {
    return ip.split(".").every(part => part.length <= 3 && Number(part) <= 255);
  }
  // IPv6 syntax is fully checked by the backend; reject URLs, hostnames and ports here.
  return ip.includes(":") && /^[a-fA-F0-9:.]+$/.test(ip);
}
